/** Workflow values for `crm.Lead.status` / `Client.lead_workflow_status` (must match backend Lead.STATUS_CHOICES). */
export const LEAD_WORKFLOW_STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'attempted', label: 'Attempted' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'replied', label: 'Replied' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'unqualified', label: 'Unqualified' },
] as const;
